import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditCentroCentro extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.centroCentro.id ? this.props.centroCentro.id : uuidv4(),
            hijo: this.props.centroCentro.hijo ? this.props.centroCentro.hijo : this.props.centros[0].id,
            //centroName: this.props.centroCentro.tipoZona ? this.props.centroCentro.tipoZona : this.props.centros[0].descr,
        };
    };


    fillCentros = () => {

        return this.props.centros.filter(c => c.isGroup === false).map(c => {

            return (
                <option key={c.id} value={c.id}>{c.centro}</option>
            );

        });

    };

    handleCentroChange = (event) => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            hijo: value,
            //centroName: this.props.tiposZona.find(tz => tz.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <form className={classes.root} autoComplete="off">

                <div className={classes.containerPair}>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="centro-placeholder">
                            Centro
                            </InputLabel>
                        <Select
                            native
                            value={this.state.hijo}
                            onChange={(event) => this.handleCentroChange(event)}
                            name="centro"
                        >
                            {this.fillCentros()}
                        </Select>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const centro = {
                            id: this.state.id,
                            hijoId: this.state.hijo,
                            padreId: this.props.centroid
                        };

                        if (this.props.checkCentro(centro)) {

                            this.props.okHandler(centro);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>
            </form>
        );

    };


};

EditCentroCentro.propTypes = {
    centroCentro: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkCentro: PropTypes.func.isRequired,
    centroid: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCentroCentro);